import { useState, useEffect } from 'react';
import { useDebounce } from '@uidotdev/usehooks';

export function useBufferState<T>(onChange: (value: T) => void, delay: number = 700) {
  const [bufferState, setBufferState] = useState<T | null>(null);
  const debouncedBufferState = useDebounce(bufferState, delay);

  useEffect(() => {
    if (debouncedBufferState !== null) {
      onChange(debouncedBufferState);
    }
  }, [debouncedBufferState]);

  return {
    bufferState,
    setBufferState,
  };
}
